export default __webpack_public_path__ + "static/media/bukopin-finance.bcd617e5.png";